import { ElementRef, Renderer2, Directive, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { environment } from '../../../environments/environment';

@Directive({
  selector: '[appHref]'
})
export class HrefDirective implements OnInit {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private localize: LocalizeRouterService) { }

  @Input() appHref: string;

  ngOnInit() {
    if (!this.appHref) { return; }

    let href = this.appHref;
    const qParams = this.appHref.split('?')[1];

    href = qParams ?
      this.localize.translateRoute(this.appHref.split('?')[0]).toString() + '?' + qParams :
      this.localize.translateRoute(this.appHref).toString();

    const baseHref = environment.baseHref;
    if (baseHref) { href = baseHref + href; }

    this.renderer.setProperty(this.el.nativeElement, 'href',  href);
  }
}

